import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const useModalStore = create(
  devtools(
    (set, get) => ({
      // Modal states for different raw masters
      modals: {
        item: { isOpen: false, editId: null },
        color: { isOpen: false, editId: null },
        size: { isOpen: false, editId: null },
        shape: { isOpen: false, editId: null },
        unit: { isOpen: false, editId: null },
        brand: { isOpen: false, editId: null },
        uom: { isOpen: false, editId: null },
        vendor: { isOpen: false, editId: null },
        customer: { isOpen: false, editId: null },
        transporter: { isOpen: false, editId: null },
        group: { isOpen: false, editId: null },
        profiling: { isOpen: false, editId: null },
        pricelist: { isOpen: false, editId: null },
        subbrand: { isOpen: false, editId: null },
        discount: { isOpen: false, editId: null },
        cndntypes: { isOpen: false, editId: null },
        voucher: { isOpen: false, editId: null, data: null },
        company: { isOpen: false, editId: null },
        godown: { isOpen: false, editId: null },
        user: { isOpen: false, editId: null },
        schmitemaster: { isOpen: false, editId: null },
        schissue: { isOpen: false, editId: null },
        area: { isOpen: false, editId: null },
        sizeGrouping: { isOpen: false, editId: null },
      },
      
      // Track the order of opened modals for z-index stacking
      modalStack: [],
      
      // Generic actions for any modal type
      openModal: (modalType, editId = null, data = null) =>
        set(
          (state) => {
            // Add to stack if not already there
            const newStack = state.modalStack.includes(modalType) 
              ? state.modalStack 
              : [...state.modalStack, modalType];
            
            return {
              modals: {
                ...state.modals,
                [modalType]: { isOpen: true, editId, data }
              },
              modalStack: newStack
            };
          },
          false,
          `open-${modalType}-modal`
        ),
      
      closeModal: (modalType) =>
        set(
          (state) => ({
            modals: {
              ...state.modals,
              [modalType]: { isOpen: false, editId: null, data: null }
            },
            modalStack: state.modalStack.filter(type => type !== modalType)
          }),
          false,
          `close-${modalType}-modal`
        ),
      
      // Convenience getters
      isModalOpen: (modalType) => get().modals[modalType]?.isOpen || false,
      getModalEditId: (modalType) => get().modals[modalType]?.editId || null,
      getModalData: (modalType) => get().modals[modalType]?.data || null,
      
      // Get z-index for a modal based on its position in the stack
      getModalZIndex: (modalType) => {
        const state = get();
        const stackIndex = state.modalStack.indexOf(modalType);
        // Base z-index is 50, each subsequent modal gets +10
        return stackIndex >= 0 ? 50 + (stackIndex * 10) : 50;
      },
      
      // Close all modals (useful for cleanup)
      closeAllModals: () =>
        set(
          (state) => {
            const newModals = {};
            Object.keys(state.modals).forEach(key => {
              newModals[key] = { isOpen: false, editId: null };
            });
            return { 
              modals: newModals,
              modalStack: []
            };
          },
          false,
          'close-all-modals'
        ),
    }),
    {
      name: 'modal-store', // Name for devtools
    }
  )
);

export default useModalStore; 